// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"152":"0991975a","569":"83f35b7f"}[chunkId] + ".css";
};